import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://dpos.co.in';
const DEFAULT_IMAGE = `${BASE_URL}/logo512.png`;

export default function SEOHead({
  title = 'DPOS – #1 F&B & POS Software | Best Restaurant Management Software',
  description = 'DPOS is the world\'s best F&B and POS software trusted by restaurants globally. Manage orders, inventory, billing and more.',
  canonical,
  ogImage = DEFAULT_IMAGE,
  noindex = false,
}) {
  // nginx 301-redirects any prerendered route without a trailing slash to the
  // slash form (e.g. /pos -> /pos/) - point canonical/og:url straight at that
  // final URL so crawlers don't spend a redirect hop on every page.
  const path = canonical && canonical !== '/' && !canonical.endsWith('/') ? `${canonical}/` : canonical;
  const url = path ? `${BASE_URL}${path}` : BASE_URL;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex
        ? <meta name="robots" content="noindex, nofollow" />
        : <meta name="robots" content="index, follow" />
      }
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="DPOS" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@dpos_official" />
    </Helmet>
  );
}
